module.exports = __webpack_public_path__ + "img/lkdn.1a799ec7.svg";